/*
 * @Author: DLLCNX dllcnx@foxmail.com
 * @Date: 2023-12-26 09:56:15
 * @LastEditors: DLLCNX dllcnx@foxmail.com
 * @LastEditTime: 2024-02-21 12:10:18
 * @FilePath: /smartEarthDemo/src/main.js
 * @Description: 
 */
import Vue from 'vue'
import router from './router/router'
import store from './store'
import * as Cesium from "cesium/Cesium";
import 'cesium/Widgets/widgets.css'
import './assets/main.css'
import './assets/font/iconfont.css';
import echarts from 'echarts'
import 'echarts-gl';
import L from "leaflet";
import "leaflet/dist/leaflet.css";
// element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// antd
import Anchor from 'ant-design-vue/lib/anchor'
import 'ant-design-vue/dist/antd.css'

import App from './App.vue'

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.config.productionTip = false;
Vue.use(Anchor);
Vue.use(ElementUI);
Vue.prototype.axios = axios;
Vue.prototype.$echarts = echarts

Vue.use(VueAxios, axios);
Cesium.Ion.defaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIzNWZhODgzMC1iNmE5LTQzNWMtOTdiYi00NzAyMzhmZDdmNjgiLCJpZCI6MTg3NTAyLCJpYXQiOjE3MDQyNDkwODl9.81WSf-TbP_6rNXQpVmuQaca_IrKpBje4NKk-BQxt4hg';
if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    Vue.prototype.$device = 'mobile'
} else {
    Vue.prototype.$device = 'pc'
}

new Vue({
    router,
    store,
    beforeCreate() {
        window.Cesium = Cesium;
    },
    render: h => h(App)
}).$mount('#app');
